import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Contribute from "./pages/Contribute";
import Wall from "./pages/Wall";
import Admin from "./pages/Admin";
import FarmsFromSpace from "./pages/FarmsFromSpace";
import FarmFromSpace from "./pages/FarmFromSpace";
import Letters from "./pages/Letters";
import Forests from "./pages/Forests";
import Forest from "./pages/Forest";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-sritaru-50">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/contribute" element={<Contribute />} />
            <Route path="/wall" element={<Wall />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/farms" element={<FarmsFromSpace />} />
            <Route path="/farm/:id" element={<FarmFromSpace />} />
            <Route path="/letters" element={<Letters />} />
            <Route path="/forests" element={<Forests />} />
            <Route path="/forest/:id" element={<Forest />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
